import {PeriodsHttp} from "../../../http/PeriodsHttp";

export default {
    async setPeriods({commit}) {
        const periods = await PeriodsHttp.getPeriods().then(result => result.data);
        commit('setPeriods', periods);
    },
    setActivePeriod({commit}, activePeriod) {
        commit('setActivePeriod', activePeriod);
    },
    setManagePeriodDialog({commit}, status) {
        commit('setManagePeriodDialog', status);
    },
    setManageDeletePeriodDialog({commit}, status) {
        commit('setManageDeletePeriodDialog', status);
    }
}
